import { IRectangle, List, mergeStyleSets, Stack } from '@fluentui/react';
import * as React from 'react';
import { useState } from 'react';
import { isKeplerAccreditor } from '../lib/helper';
import { ICourseWorkFlat } from '../types/IAssignment';
import { IListViewCourseworksProperties, noAssignmentsComponentString } from './coursework';
import PreviewCard from './previewCard';
import SlideShow from './slideShow.tsx';

export const previewCardHeight = 300;
export const previewCardWidth = 420;

const gridItemHeight = previewCardHeight + 160;
const gridItemWidth = previewCardWidth + 20;

const classNames = mergeStyleSets({
  galleryView: {
    overflow: 'hidden',
    position: 'relative',
  },
  gridItem: {
    padding: 10,
    margin: 10,
    width: gridItemWidth,
    minWidth: gridItemWidth,
    maxWidth: gridItemWidth,
    height: gridItemHeight,
    minHeight: gridItemHeight,
    maxHeight: gridItemHeight,
    outline: 'none',
    position: 'relative',
    float: 'left',
    selectors: {
      'focus:after': {
        content: '',
        position: 'absolute',
        left: 2,
        right: 2,
        top: 2,
        bottom: 2,
        boxSizing: 'border-box'
      },
    },
  }
});

const Galleryview: React.FunctionComponent<{ props: IListViewCourseworksProperties }> = ({ props }) => {

  const columnCount = React.useRef(0);
  const rowHeight = React.useRef(0);
  let files = props.files;
  if (props.authContext && !props.authContext?.KeplerAuthStatus?.isKeplerAdministrator && props.accreditorHiddenCourseWorks && props.accreditorHiddenCourseWorks.length > 0) {
    files = files.filter(f => !props.accreditorHiddenCourseWorks?.includes(f.FilePath));
  }

  const [slideShowItem, setSlideShowItem] = useState<ICourseWorkFlat>();
  let items = (props.selectedMyCoursework && props.currentStudent) ? [...files].filter(c => c.Student === props.currentStudent) : [...files];

  if (props.authContext && isKeplerAccreditor(props.authContext) && props.accreditationRulesContext?.Result?.find(ar => ar.Accreditor.AccreditorName === props.authContext?.KeplerAuthStatus.idTokenClaims.companyName)?.Accreditor.ShouldAnonymizeStudents) {
    let uniqueStudentMapping: { [x: string]: string } = {};
    items = items.map(i => {
      if (!uniqueStudentMapping[i.Student]) {
        uniqueStudentMapping[i.Student] = `Student ${Object.keys(uniqueStudentMapping).length + 1}`;
      }
      let retVal: ICourseWorkFlat = { ...i, Student: uniqueStudentMapping[i.Student] }
      return retVal;
    })
  }

  const getItemCountForPage = React.useCallback((itemIndex?: number | undefined, visibleRect?: IRectangle | undefined) => {
    if (itemIndex === 0) {
      columnCount.current = Math.ceil(visibleRect?.width || 320 / 366);
      rowHeight.current = Math.floor(visibleRect?.width || 320 / columnCount.current);
    }
    return columnCount.current * 3;
  }, []);

  return <Stack tokens={{ childrenGap: 10 }}>
    <List
      className={classNames.galleryView}
      renderedWindowsAhead={2}
      items={items}
      getItemCountForPage={getItemCountForPage}
      onRenderCell={(file, index) => {
        return <PreviewCard
          maxFileSizeBeforeStream={props.maxFileSizeBeforeStream}
          semester={props.semseter}
          shouldGetDataFromCanvasAPIs={props.shouldGetDataFromCanvasAPIs}
          rootStyle={classNames.gridItem}
          index={index!}
          key={`preview-card-${file!.FilePath}`}
          file={file!}
          authContext={props.authContext}
          accreditationRulesContext={props.accreditationRulesContext}
          setSlideShowItem={(file) => {
            setSlideShowItem(file);
          }}
        />
      }} />

    {slideShowItem && <SlideShow {...{
      maxFileSizeBeforeStream: props.maxFileSizeBeforeStream,
      currentFile: slideShowItem, files: items, onClose: () => {
        setSlideShowItem(undefined);
      }, authContext: props.authContext, accreditationRulesContext: props.accreditationRulesContext
    }} />}
    {items.length === 0 && <Stack horizontalAlign="start">{noAssignmentsComponentString(props.studentsAssignedToAccreditor)}</Stack>}
  </Stack>;
};

export default Galleryview;